import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";

import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";

import { ApiRoutesItem } from "@/api/routes";
import { AIRPORT_MAP } from "@/constants/airport";
import { NEED_BACKGROUND_PROGRAM, airlineBgColor } from "@/constants/config";
import { PROGRAM_IMG } from "@/constants/programs";
import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";
import CabinColorItem from "@/pages/Routes/components/RoutesItem/CabinColorItem";
import { CabinsType } from "@/typings";

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

dayjs.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s",
    // s: "seconds",
    // m: "1 minute",
    // mm: "%d minutes",
    s: "just now",
    m: "minutes ago",
    mm: "minutes ago",
    h: "1 hour ago",
    hh: "%d hours ago",
    d: "1 day ago",
    dd: "%d days ago",
    M: "1 month ago",
    MM: "%d months ago",
    y: "1 year ago",
    yy: "%d years ago",
  },
});

const RoutesItem = (props: {
  data: ApiRoutesItem;
  onClick: (
    params: ApiRoutesItem & {
      type: CabinsType;
    }
  ) => void;
  onLoad: () => void;
}) => {
  const { data } = props;
  const { isPc } = usePlatform();
  const theme = useThemeData();
  const airports = data.route.split("-");
  return (
    <Grid container className={`p-[10px]`}>
      <Grid item xs={12} md={3.8}>
        <div className="flex items-center h-[100%]">
          {/* <img className="w-[50px]" onLoad={props.onLoad} src={PROGRAM_IMG[data.program]} alt="" /> */}

          <Box
            className={isPc ? "rounded-[3px] p-[1px] flex items-center h-[50px] w-[75px]" : "rounded-[3px] p-[1px] flex items-center h-[50px] w-[50px]"}
            sx={{
              backgroundColor:
                theme.isDarkMode && NEED_BACKGROUND_PROGRAM.includes(data.program)
                  ? airlineBgColor
                  : "transparent",
            }}
          >
            <img
              className="w-[100%]"
              onLoad={props.onLoad}
              src={PROGRAM_IMG[data.program]}
              alt=""
            />
          </Box>
          <div className="text-center ml-[20px]">
            <Typography fontSize={13} variant="body2">
              {dayjs(data.date).format("ddd")}
            </Typography>
            <Box
              className="px-[5px] rounded-[2px]"
              sx={{ backgroundColor: theme.isDarkMode ? airlineBgColor : "#e1f5fe" }}
            >
              <Typography fontSize={13} variant="body2">
                {dayjs(data.date).format("M/D")}
              </Typography>
            </Box>
          </div>
          <div className="flex-1 ml-[40px] md:text-center flex flex-col justify-center">
            <div>
              <Tooltip title={`${AIRPORT_MAP[airports[0]]?.name ?? 'Unknown Name'}, ${AIRPORT_MAP[airports[0]]?.city ?? 'Unknown City'}`}>
                <Typography className="inline" fontSize={14}>
                  {airports[0]}
                </Typography>
              </Tooltip>
              <Typography className="inline" fontSize={14}>
                {" - "}
              </Typography>
              <Tooltip title={`${AIRPORT_MAP[airports[1]]?.name ?? 'Unknown Name'}, ${AIRPORT_MAP[airports[1]]?.city ?? 'Unknown City'}`}>
                <Typography className="inline" fontSize={14}>
                  {airports[1]}
                </Typography>
              </Tooltip>
            </div>

            <Typography variant="caption" fontSize={13}>
              Last Seen: {data.points.ls ? dayjs(data.points.ls * 1000).fromNow() : "few days ago"}
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid
        item
        xs={11}
        md={7.5}
        container
        rowSpacing={{
          xs: 1,
          md: 0,
        }}
        columnSpacing={1}
        className="items-center"
        style={{
          marginTop: isPc ? 0 : "10px",
          paddingLeft: isPc ? "20px" : "0",
        }}
      >
        <Grid item xs={6} md={3}>
          <CabinColorItem
            data={data}
            type="y"
            onClick={() => {
              props.onClick({
                ...data,
                type: "Economy",
              });
            }}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <CabinColorItem
            data={data}
            type="w"
            onClick={() => {
              props.onClick({
                ...data,
                type: "Premium Economy",
              });
            }}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <CabinColorItem
            data={data}
            type="j"
            onClick={() => {
              props.onClick({
                ...data,
                type: "Business",
              });
            }}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <CabinColorItem
            data={data}
            type="f"
            onClick={() => {
              props.onClick({
                ...data,
                type: "First",
              });
            }}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs={1}
        md={0.7}
        style={{
          marginTop: isPc ? 0 : "20px",
        }}
      >
        <div className="flex flex-col items-start md:items-end justify-center h-[100%]">
          <IconButton
            size="small"
            onClick={() => {
              props.onClick({
                ...data,
                type: "Economy",
              });
            }}
          >
            <InfoOutlined />
          </IconButton>
        </div>
      </Grid>
    </Grid>
  );
};

export default RoutesItem;
